import { Component, Inject, OnInit } from '@angular/core';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SolicitacaoModel } from 'app/model/solicitacao/solicitacao.model';

@Component({
  selector: 'app-detalhes-solicitacao',
  templateUrl: './detalhes-solicitacao.component.html',
  styleUrls: ['./detalhes-solicitacao.component.scss']
})
export class DetalhesSolicitacaoComponent implements OnInit {
  
  solicitacao = {} as SolicitacaoModel;
  solicitacaoId;
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<DetalhesSolicitacaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private solicitacaoService: SolicitacaoService) { 
      this.solicitacaoId = data.numeroSolic;
    }

  ngOnInit() {
    this.getSolicitacao(this.solicitacaoId);
  }

  getSolicitacao(solicitacaoId) {
    this.solicitacaoService.getSolicitacao(solicitacaoId).subscribe(data => {
      console.log(data);
      this.solicitacao = data;
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/detalhes-solicitacao/detalhes-solicitacao.component.ts